import React from 'react';
export function PainPointsSection() {
  const points = [{
    emoji: '😰',
    title: 'Domenica sera — Stress',
    text: "Un'altra domenica a preparare la lezione da zero, mentre gli altri riposano."
  }, {
    emoji: '📱',
    title: 'Nessun sistema',
    text: 'Salvi screenshot da Instagram e non ritrovi mai niente quando ti serve.'
  }, {
    emoji: '🤷',
    title: 'Allieve "esigenti"',
    text: 'Ognuna con un bisogno diverso — ansia, sonno, mal di schiena — e tu ricominci ogni volta.'
  }];
  return <section className="py-20 px-4 bg-[#f2ebe1]" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-108">
          👉 Riconosci queste scene?
        </h2>
        <p className="text-brand-gray mb-12" data-id="element-109">
          Se rispondi sì anche solo a una — questo kit è per te
        </p>

        <div className="space-y-4 mb-12" data-id="element-110">
          {points.map((point, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-sm flex items-start gap-4 text-left border border-white/50 hover:border-brand-creamDark transition-colors" data-id="element-111">
              <span className="text-3xl shrink-0" data-id="element-112">{point.emoji}</span>
              <div data-id="element-113">
                <h3 className="font-serif font-bold text-brand-text md:text-lg mb-1" data-id="element-114">
                  {point.title}
                </h3>
                <span className="text-brand-gray font-medium" data-id="element-115">
                  {point.text}
                </span>
              </div>
            </div>)}
        </div>

        <p className="text-xl md:text-2xl font-serif italic text-brand-green font-bold" data-id="element-116">
          Ti riconosci? Allora Yoga Pronta è per te →
        </p>
      </div>
    </section>;
}